/**
 * 系统变量配置
 *
 * 公司内部数据Mock服务: http://doc.myoas.com/pages/viewpage.action?pageId=40078126
 * */

const isDebug = ['development'].indexOf(process.env.NODE_ENV) !== -1; // 是否开启VUE的debug模式
const isDev = isDebug; // 是否使用开发环境的接口
const isMock = false; // 是否使用mock数据

module.exports = {
    isDebug,
    isDev,
    isMock,
    actDomain: getActDomain()
};
function getActDomain() {
    if(isDev) {
        return 'https://global-activity-test.wanyol.com';
    }
    let actDomain = 'https://activity-gl.cdo.heytapmobile.com';
    if (typeof window === 'undefined') {
        return '';
    }
    // let region = '';
    let _pageData = window.pageData;
    if (_pageData && _pageData.pageMap && _pageData.pageMap.region) {
        switch (_pageData.pageMap.region) {
            case 'IN': // 印度
                actDomain = 'https://activity-in.cdo.heytapmobile.com';
                break;
            case 'ID': // 印尼
                actDomain = 'https://activity-id.cdo.heytapmobile.com';
                break;
            default: //越南 泰国 菲律宾 马来西亚 台湾
                actDomain = 'https://activity-gl.cdo.heytapmobile.com';
                break;
        }
    }
    return actDomain;
}



// WEBPACK FOOTER //
// ./src/utils/system.js